module.exports = __webpack_public_path__ + "img/logo.225559da.png";